// import { BankMasterFormPayloadType } from 'api/nach';

export const dummyData: any = [
  {
    BankName: 'HDFC',
    NachType: 'NACH',
    BankId: '1',
    Status: 'Active',
  },
  {
    BankName: 'ICICI',
    NachType: 'NACH',
    BankId: '2',
    Status: 'Inactive',
  },
  {
    BankName: 'SBI',
    NachType: 'PhysicalNach',
    BankId: '3',
    Status: 'Active',
  },
];
